module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            message: '@?',
            customTooltipClass: '@?',
        },
        template: `<div class="tooltipQuestionmark" ng-class="{{customTooltipClass}}" oly-tooltip="message">
                        <i class="iconww-DeliveryNotSet"></i>
                    </div>`,
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/tooltip/tooltip-questionmark.directive.js